import { EventsAction } from '@makyoapp/makyo-sdk/models/AppBuilder'
import { IActionRepeaterValue } from '@makyoapp/makyo-common'

const ACTION_SEQUENCE_KEY = 'action-sequence'
const DIALOG_SEQUENCE_KEY = 'dialog-sequence'

export function fromSdkActions(actions: EventsAction, optKey = ACTION_SEQUENCE_KEY): IActionRepeaterValue[] {
  const actionSequence = actions?.[optKey] ?? actions?.[DIALOG_SEQUENCE_KEY]
  return actionSequence?._Actions ?? []
}

export function toSdkActions(actions: IActionRepeaterValue[], optKey = ACTION_SEQUENCE_KEY): EventsAction {
  return {
    [optKey]: {
      _Cond: '',
      _Actions: actions,
    },
  }
}
